module.exports = "<span uib-dropdown> <a href id=dropdown class=text-info uib-dropdown-toggle> <i class=\"fa fa-globe fa-fw\"></i> {{selectedLang.short}} <span class=caret></span> </a> <ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button> <li ng-repeat=\"language in languages\"> <div class=btn ng-click=switchLanguage(language)>{{language.title | translate}}</div> </li> </ul> </span> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/directives/languageSwitch/languageSwitch.html
// module id = 315
// module chunks = 0